export default __webpack_public_path__ + "static/media/0095.17e4a43d.jpg";